import * as actions from "Actions";
import * as api from "Api";
import { pushSourceToken } from "Utils";

export const fetchTeam = ({ limit = 100, isPublic = true }) => {
  return (dispatch, getState) => {
    let sourceToken = pushSourceToken("FETCH_TEAM", dispatch);

    const { token, navCommunity } = getState().auth;
    const { community } = getState().params.publicPortal;

    return dispatch(
      actions.fetchTeam(
        api.getTeam({
          token,
          limit,
          communityId: community ? community.id : null,
          navCommunity,
          sourceToken
        })
      )
    );
  };
};

export const saveTeamSettings = data => {
  return (dispatch, getState) => {
    const { token, navCommunity } = getState().auth;

    return dispatch(
      actions.saveTeamSettings(
        api.saveTeamSettings({
          token,
          communityId: navCommunity.id,
          data
        })
      )
    );
  };
};



// WEBPACK FOOTER //
// ./src/actions/thunks/user.js